import Page from "../../pages/website/Page";
import RefSource from "../../ref-monitor/RefSource";
import {
  Configuration,
  Page as PageType,
  Site,
} from "../../resources/modelTypes";
import { RootState } from "../../resources/reduxTypes";
import { selectCollection } from "../../resources/selectors";
import ContentSections from "../../website/components/ContentSections";
import EmptyPage from "../../website/components/EmptyPage";
import SitePreviewContext from "../../website/components/SitePreviewContext";
import React, { memo } from "react";
import { useContext } from "react";
import { connect } from "react-redux";

export type PhotosProps = {
  configuration: Configuration;
  dashboardUrl: (siteId: number) => string;
  id: string;
  isMultiPage?: boolean;
  page: PageType;
  site: Site;
  source: string;
  title: string;
};

type PhotoPropsWithRedux = {
  hasSections: boolean;
} & PhotosProps;

const Photos: React.FC<PhotoPropsWithRedux> = ({
  configuration,
  dashboardUrl,
  hasSections,
  id,
  page,
  site,
  source,
  title,
}) => {
  const { isMobile } = useContext(SitePreviewContext);

  return hasSections ? (
    <Page id={id} pageData={page} removeSpacing title={title}>
      <ContentSections isMobileView={isMobile} pageId={page.id} />
    </Page>
  ) : (
    <div>
      <EmptyPage
        configuration={configuration}
        headline="You haven't added any media yet."
        id={id}
        pageData={page}
        removeSpacing
        source={source}
        title={title}
      >
        Once you&apos;ve added media in the{" "}
        <a href={`${dashboardUrl(site.id)}/pages/photos`} target="_parent">
          Wedding Website Manager
        </a>
        , they will show up here with all the details.
      </EmptyPage>
    </div>
  );
};

const mapStateToProps = (state: RootState, props: PhotosProps) => {
  const { page } = props;

  const collection = selectCollection(state.resources.sections, {
    page: page.id,
  });

  const hasSections =
    [...collection.items, ...collection.resource.staged.create].length > 0;

  return {
    hasSections,
  };
};

const ConnectedPhotos = RefSource(
  connect(mapStateToProps)(Photos),
) as unknown as React.FC<PhotosProps>;

const MemoizedPhotos = memo(ConnectedPhotos);

export { MemoizedPhotos as Photos };
